import * as types from './types'

export default {
  [types.SERVER_SHOW_OVERLAY] (state, value) {
    state.server.showOverlay = value
  },

  [types.SERVER_OVERLAY_MESSAGE] (state, value) {
    state.server.overlayMessage = value
  },

  [types.SERVER_OVERLAY_FUNCTION] (state, value) {
    state.server.overlayFunction = value
  }
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/httpRequests/mutations.js
// module id = null
// module chunks = 